import { useState } from 'react';
import Header from '../../../components/layout/Header';
import Footer from '../../../components/layout/Footer';
import WhatsAppFloat from '../../../components/ui/WhatsAppFloat';

const ObtencionFundingPage = () => {
  const [selectedPlan, setSelectedPlan] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState('beneficios');



  const fundingTypes = [
    {
      icon: 'ri-bank-line',
      title: 'Préstamos SBA',
      description: 'Préstamos respaldados por el gobierno con tasas preferenciales y términos favorables.',
      amount: '$50K - $5M',
      rate: '6-10% APR',
      term: '5-25 años'
    },
    {
      icon: 'ri-building-line',
      title: 'Líneas de Crédito Comerciales',
      description: 'Acceso flexible a capital para gastos operativos y oportunidades de crecimiento.',
      amount: '$10K - $500K',
      rate: '8-15% APR',
      term: 'Revolving'
    },
    {
      icon: 'ri-funds-line',
      title: 'Capital de Inversión',
      description: 'Inversión de capital privado para empresas con alto potencial de crecimiento.',
      amount: '$100K - $10M+',
      rate: 'Equity based',
      term: '3-7 años'
    },
    {
      icon: 'ri-truck-line',
      title: 'Financiamiento de Equipos',
      description: 'Capital específico para la compra de maquinaria, vehículos y equipos empresariales.',
      amount: '$25K - $1M',
      rate: '7-12% APR',
      term: '2-7 años'
    },
    {
      icon: 'ri-home-line',
      title: 'Préstamos Inmobiliarios',
      description: 'Financiamiento para propiedades comerciales e inversiones inmobiliarias.',
      amount: '$100K - $20M',
      rate: '5-9% APR',
      term: '10-30 años'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Capital de Trabajo',
      description: 'Financiamiento rápido para cubrir gastos operativos y flujo de efectivo.',
      amount: '$5K - $250K',
      rate: '10-25% APR',
      term: '3-24 meses'
    }
  ];

  const faqs = [
    {
      question: '¿Qué requisitos necesito para calificar para funding?',
      answer: 'Los requisitos varían según el tipo de financiamiento, pero generalmente incluyen: score crediticio de 650+, al menos 2 años en el negocio, ingresos anuales mínimos de $100K, y documentación financiera completa. Evaluamos cada caso individualmente.'
    },
    {
      question: '¿Cuánto tiempo toma el proceso de aprobación?',
      answer: 'El tiempo varía según el tipo de funding: líneas de crédito pueden aprobarse en 1-2 semanas, préstamos SBA toman 4-8 semanas, y capital de inversión puede tomar 8-16 semanas. Nuestro proceso optimizado acelera significativamente estos tiempos.'
    },
    {
      question: '¿Necesito garantías personales para obtener funding?',
      answer: 'Depende del tipo de financiamiento y monto. Para líneas de crédito empresariales y ciertos préstamos, podemos estructurar opciones sin garantías personales. Para montos mayores, algunas garantías pueden ser requeridas.'
    },
    {
      question: '¿Qué documentación necesito preparar?',
      answer: 'Típicamente necesitarás: estados financieros de 2-3 años, declaraciones de impuestos, estados de cuenta bancarios, business plan, proyecciones financieras, y documentos corporativos. Te ayudamos a preparar todo correctamente.'
    },
    {
      question: '¿Pueden ayudarme si mi negocio es nuevo?',
      answer: 'Sí, tenemos opciones para startups y negocios nuevos, incluyendo préstamos basados en activos, financiamiento de equipos, y acceso a inversionistas ángel. El enfoque varía según tu industria y modelo de negocio.'
    },
    {
      question: '¿Qué pasa si me rechazan en otros lugares?',
      answer: 'Tenemos acceso a una red extensa de prestamistas alternativos y inversionistas privados. Muchos de nuestros clientes han sido rechazados en bancos tradicionales pero obtuvieron funding a través de nuestros canales especializados.'
    }
  ];



  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Acceso a Capital Sin Límites',
      description: 'Conectamos con prestamistas e inversionistas que pueden proporcionar desde $10K hasta $10M+ según tus necesidades.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Sin Garantías Personales',
      description: 'Estructuramos opciones de financiamiento que protegen tus activos personales y familiares.'
    },
    {
      icon: 'ri-speed-up-line',
      title: 'Proceso Acelerado',
      description: 'Nuestras relaciones exclusivas permiten aprobaciones más rápidas que los canales tradicionales.'
    },
    {
      icon: 'ri-handshake-line',
      title: 'Términos Negociados',
      description: 'Negociamos las mejores tasas, términos y condiciones en tu nombre con nuestra experiencia.'
    },
    {
      icon: 'ri-team-line',
      title: 'Red de Inversionistas VIP',
      description: 'Acceso exclusivo a nuestra red de inversionistas privados y fondos institucionales.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Crecimiento Empresarial',
      description: 'El capital adecuado te permite escalar rápidamente y aprovechar oportunidades de mercado.'
    }
  ];

  const process = [
    {
      step: '01',
      title: 'Evaluación Inicial',
      description: 'Analizamos tu situación financiera, necesidades de capital y objetivos empresariales.',
      duration: '1-2 días'
    },
    {
      step: '02',
      title: 'Estrategia de Funding',
      description: 'Diseñamos una estrategia personalizada y identificamos las mejores opciones de financiamiento.',
      duration: '3-5 días'
    },
    {
      step: '03',
      title: 'Preparación de Documentos',
      description: 'Preparamos toda la documentación necesaria y optimizamos tu perfil para prestamistas.',
      duration: '1-2 semanas'
    },
    {
      step: '04',
      title: 'Presentación a Prestamistas',
      description: 'Presentamos tu caso a nuestra red de prestamistas e inversionistas calificados.',
      duration: '2-4 semanas'
    },
    {
      step: '05',
      title: 'Negociación y Cierre',
      description: 'Negociamos términos favorables y te acompañamos hasta el cierre exitoso.',
      duration: '1-3 semanas'
    }
  ];

  return (
    <div className="min-h-screen bg-black pt-20">
      <Header />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-black via-gray-900 to-black py-20 lg:py-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-vip-gold/10 to-transparent"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6">
                  Obtención de <span className="bg-gradient-to-r from-vip-gold to-vip-gold-light bg-clip-text text-transparent">Funding</span>
                </h1>
                <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                  Accede al capital que necesitas para hacer crecer tu negocio. Desde $10K hasta $10M+ con las mejores tasas y términos del mercado.
                </p>

                <div className="grid grid-cols-3 gap-6 mb-8">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-vip-gold mb-2">$20M+</div>
                    <div className="text-gray-300 text-sm">Capital Facilitado</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-vip-gold mb-2">1,200+</div>
                    <div className="text-gray-300 text-sm">Empresas Financiadas</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-vip-gold mb-2">95%</div>
                    <div className="text-gray-300 text-sm">Tasa de Aprobación</div>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="https://web.cashflow.vip/widget/booking/dZafhFlPIO82YbvGywB0"
                    className="bg-gradient-to-r from-vip-gold to-vip-gold-light text-black px-8 py-4 rounded-full font-bold text-lg hover:shadow-lg hover:shadow-vip-gold/30 transition-all duration-300 whitespace-nowrap text-center"
                  >
                    Evaluación Gratuita
                  </a>
                  <a
                    href="https://www.skool.com/cashflow"
                    className="border-2 border-vip-gold text-vip-gold px-8 py-4 rounded-full font-bold text-lg hover:bg-vip-gold hover:text-black transition-all duration-300 whitespace-nowrap text-center"
                  >
                    Ver Comunidad
                  </a>
                </div>
              </div>

              <div className="relative">
                <img
                  src="/images/878e867da1b36d45914141269b250482.webp"
                  alt="Obtención de Funding"
                  className="w-full h-auto rounded-2xl shadow-2xl"
                />
                <div className="absolute -bottom-6 -left-6 bg-gray-800 border border-gray-700 rounded-xl p-4">
                  <div className="flex items-center gap-3">
                    <i className="ri-funds-line text-2xl text-vip-gold"></i>
                    <div>
                      <div className="font-bold text-white">Capital Disponible</div>
                      <div className="text-sm text-gray-400">$10K - $10M+</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Funding Types */}
      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Tipos de <span className="text-vip-gold">Financiamiento</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Acceso a múltiples opciones de capital adaptadas a diferentes necesidades empresariales
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {fundingTypes.map((type, index) => (
              <div key={index} className="bg-gray-800 rounded-2xl p-8 shadow-lg hover:shadow-xl hover:shadow-vip-gold/20 transition-all duration-300 border border-gray-700 group">
                <div className="w-16 h-16 bg-gradient-to-br from-vip-gold to-vip-gold-light rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${type.icon} text-2xl text-black`}></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">{type.title}</h3>
                <p className="text-gray-300 mb-6">{type.description}</p>

                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-400">Monto:</span>
                    <span className="text-vip-gold font-bold">{type.amount}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-400">Tasa:</span>
                    <span className="text-white font-medium">{type.rate}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-400">Término:</span>
                    <span className="text-white font-medium">{type.term}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              ¿Por Qué Elegir Nuestro <span className="text-vip-gold">Servicio?</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Ventajas exclusivas que nos diferencian de prestamistas tradicionales
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-gray-800 rounded-2xl p-8 shadow-lg hover:shadow-xl hover:shadow-vip-gold/20 transition-all duration-300 border border-gray-700 group">
                <div className="w-16 h-16 bg-gradient-to-br from-vip-gold to-vip-gold-light rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${benefit.icon} text-2xl text-black`}></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">{benefit.title}</h3>
                <p className="text-gray-300">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Nuestro <span className="text-vip-gold">Proceso</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Un método sistemático y probado para obtener el funding que necesitas
            </p>
          </div>

          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-5 gap-8">
              {process.map((step, index) => (
                <div key={index} className="text-center group">
                  <div className="relative mb-6">
                    <div className="w-20 h-20 bg-gradient-to-br from-vip-gold to-vip-gold-light rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                      <span className="text-2xl font-bold text-black">{step.step}</span>
                    </div>
                    {index < process.length - 1 && (
                      <div className="hidden md:block absolute top-10 left-full w-full h-0.5 bg-gray-700"></div>
                    )}
                  </div>
                  <h3 className="text-lg font-bold text-white mb-3">{step.title}</h3>
                  <p className="text-gray-300 text-sm mb-2">{step.description}</p>
                  <div className="text-xs text-vip-gold font-medium">{step.duration}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>



      {/* FAQ Section */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Preguntas <span className="text-vip-gold">Frecuentes</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Resolvemos las dudas más comunes sobre obtención de funding
            </p>
          </div>

          <div className="max-w-4xl mx-auto space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-gray-800 rounded-xl border border-gray-700 overflow-hidden">
                <button
                  onClick={() => setSelectedPlan(selectedPlan === `faq-${index}` ? null : `faq-${index}`)}
                  className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-750 transition-colors"
                >
                  <h3 className="font-bold text-white">{faq.question}</h3>
                  <i className={`ri-arrow-${selectedPlan === `faq-${index}` ? 'up' : 'down'}-s-line text-vip-gold text-xl`}></i>
                </button>
                {selectedPlan === `faq-${index}` && (
                  <div className="px-6 pb-4">
                    <p className="text-gray-300">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-black via-gray-900 to-black">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6">
            ¿Listo para <span className="bg-gradient-to-r from-vip-gold to-vip-gold-light bg-clip-text text-transparent">Obtener</span> el Capital?
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            No dejes que la falta de capital limite tu crecimiento. Accede al funding que necesitas hoy mismo.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center mb-12">
            <a
              href="https://web.cashflow.vip/widget/booking/dZafhFlPIO82YbvGywB0"
              className="bg-gradient-to-r from-vip-gold to-vip-gold-light text-black px-10 py-5 rounded-full font-bold text-xl hover:shadow-lg hover:shadow-vip-gold/30 transition-all duration-300 whitespace-nowrap"
            >
              Evaluación Gratuita Ahora
            </a>
            <a
              href="https://www.skool.com/cashflow"
              className="border-2 border-vip-gold text-vip-gold px-10 py-5 rounded-full font-bold text-xl hover:bg-vip-gold hover:text-black transition-all duration-300 whitespace-nowrap"
            >
              Unirse a la Comunidad
            </a>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {[
              { icon: 'ri-shield-check-line', text: 'Sin Garantías Personales' },
              { icon: 'ri-time-line', text: 'Aprobación en 4-8 Semanas' },
              { icon: 'ri-customer-service-line', text: 'Soporte Especializado' }
            ].map((item, index) => (
              <div key={index} className="flex items-center justify-center gap-3 text-white">
                <i className={`${item.icon} text-2xl text-vip-gold`}></i>
                <span className="font-medium">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default ObtencionFundingPage;